import { mensagemPadrao } from 'src/dados-estaticos'
import * as Yup from 'yup'

export const createSchema = Yup.object().shape({
  // cpf: Yup.string().required(mensagemPadrao),
  nome: Yup.string().required(mensagemPadrao),
  // email: Yup.string().required(mensagemPadrao),
  dataNascimento: Yup.string().required(mensagemPadrao),
  turmaCertificacaoId: Yup.string().required(mensagemPadrao),
  situacao: Yup.string().required(mensagemPadrao)
  // statusCertificado: Yup.string().required(mensagemPadrao)
})
